import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./CommunityDetails.css";
import { useAuthContext } from "../hooks/useAuthContext";
import Modal from "react-modal";
import { initializeApp, getApps } from "firebase/app";
import { getAuth } from "firebase/auth";
import firebase from "../Firebase";
import Cookies from "js-cookie";

const PLACEHOLDER_IMG = "https://assets.streamlinehq.com/image/private/w_512,h_512,ar_1/f_auto/v1/icons/3/shooting-star-pnhn77eiumd9cca9iyw1b.png/shooting-star-ey0t57fhladsuoxiccij7.png?_a=DATAdtAAZAA0";

if (!getApps().length) {
  initializeApp(firebase);
}

Modal.setAppElement("#root");

const CommunityDetails = ({ community, onTagClick }) => {
  const navigate = useNavigate();
  const { user, dispatch, refreshUserProfile } = useAuthContext();
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [csrfToken, setCsrfToken] = useState(null);

  useEffect(() => {
    const fetchCsrfToken = async () => {
      const csrfToken = Cookies.get("mytoken");
      setCsrfToken(csrfToken);
    };
    fetchCsrfToken();
  }, []);

  const handleJoin = async () => {
    if (user?.userId) {
      if (user.listOfCommunities.includes(community._id)) {
        setModalIsOpen(true);
        return;
      }
      try {
        const auth = getAuth();
        const token = await auth.currentUser.getIdToken(true);
        const requestBody = {
          communityId: community._id,
          userId: user.userId,
        };
        const requestOptions = {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
            "X-CSRF-Token": csrfToken,
          },
          body: JSON.stringify(requestBody),
        };
        const response = await fetch(
          `${process.env.REACT_APP_API_BASE_URL}/communiUser/joinCommunity`,
          requestOptions
        );
        if (response.ok) {
          const data = await response.json();
          dispatch({
            type: "UPDATE_COMMUNITIES",
            payload: data.profile.listOfCommunities,
          });

          // Trigger profile refresh to ensure all components get fresh data
          console.log('🔄 [Community Join] Triggering profile refresh after joining community');
          setTimeout(() => {
            // Use setTimeout to allow the updateCommunities to complete first
            if (typeof refreshUserProfile === 'function') {
              refreshUserProfile();
            }
          }, 100);

          navigate("/joinAdditionalCommunity/" + community._id);
        } else {
          console.error("Failed to join community");
        }
      } catch (error) {
        console.error("Error joining community:", error);
      }
    } else {
      navigate(`/groupsearch/join/${community._id}`);
    }
  };

  const closeModal = () => {
    setModalIsOpen(false);
  };

  // Helper: get image or placeholder
  const getImageSrc = () => {
    if (community.pics && community.pics[0]) {
      return community.pics[0];
    }
    return PLACEHOLDER_IMG;
  };

  // Defensive: ensure tags is always an array
  const tagsArray =
    typeof community.tags === "string" && community.tags.length > 0
      ? community.tags.split(",")
      : Array.isArray(community.tags)
        ? community.tags
        : [];

  return (
    <div id="boxDisplayCommunityBox">
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        className="modal"
        overlayClassName="overlay"
      >
        <h2>You are already part of this community!</h2>
        <p>
          Go to messages to see who you've connected with or find another
          community to join :)
        </p>
        <button onClick={closeModal}>Close</button>
      </Modal>

      <div id="boxDisplayCommunityDetails">
        <Link to={`/${community.databaseRef}`} className="community-link">
          <h4 id="boxDisplayCommunityTitle">{community.title}</h4>
          <div className="image-container_CommunityCard">
            <img
              src={getImageSrc()}
              alt="Community"
              id="boxDisplayCommunityImage_CommunityCard"
              onError={e => { e.target.onerror = null; e.target.src = PLACEHOLDER_IMG; }}
            />
          </div>
        </Link>
        <div className="line"></div>
        <div id="boxDisplayCommunityInfo">
          <h3 id="boxDisplayCommunityLocation">{community.location}</h3>
          <h3 id="boxDisplayCommunityType">{community.type}</h3>
        </div>
        <div className="line"></div>
        <p id="boxDisplayCommunitySummary">{community.topLevelSummary}</p>
        <div id="boxDisplayCommunityTagsContainer">
  <span className="keyword-tags">
    {tagsArray.map((tag, i) =>
      <span key={i} className="keyword-dot">
        {tag.trim()}
        {i < tagsArray.length - 1 ? <span className="dot-separator" aria-hidden="true">&nbsp;•&nbsp;</span> : ""}
      </span>
    )}
  </span>
</div>

        <div className="buttonContainer">
          <button className="button" type="button" onClick={handleJoin}>
            Join
          </button>
          <Link to={`/${community.databaseRef}`} className="buttonSecondary">
            Info
          </Link>
        </div>
      </div>
    </div>
  );
};

export default CommunityDetails;

// import React, { useState, useEffect } from "react";
// import { Link, useNavigate } from "react-router-dom";
// import "./CommunityDetails.css";
// import { useAuthContext } from "../hooks/useAuthContext";
// import Modal from "react-modal";
// import { initializeApp, getApps } from "firebase/app";
// import { getAuth } from "firebase/auth";
// import firebase from "../Firebase";
// import Cookies from "js-cookie";

// const PLACEHOLDER_IMG = "https://cdn.creazilla.com/silhouettes/7966957/people-network-silhouette-f35580-md.png";

// if (!getApps().length) {
//   initializeApp(firebase);
// }

// Modal.setAppElement("#root");

// const CommunityDetails = ({ community, onTagClick }) => {
//   const navigate = useNavigate();
//   const { user, dispatch } = useAuthContext();
//   const [modalIsOpen, setModalIsOpen] = useState(false);
//   const [csrfToken, setCsrfToken] = useState(null);

//   useEffect(() => {
//     const fetchCsrfToken = async () => {
//       const csrfToken = Cookies.get("mytoken");
//       setCsrfToken(csrfToken);
//     };
//     fetchCsrfToken();
//   }, []);

//   const handleJoin = async () => {
//     if (user?.userId) {
//       if (user.listOfCommunities.includes(community._id)) {
//         setModalIsOpen(true);
//         return;
//       }
//       try {
//         const auth = getAuth();
//         const token = await auth.currentUser.getIdToken(true);
//         const requestBody = {
//           communityId: community._id,
//           userId: user.userId,
//         };
//         const requestOptions = {
//           method: "POST",
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${token}`,
//             "X-CSRF-Token": csrfToken,
//           },
//           body: JSON.stringify(requestBody),
//         };
//         const response1 = await fetch(
//           `${process.env.REACT_APP_API_BASE_URL}/userProfile/joinCommunity`,
//           requestOptions
//         );
//         if (response1.ok) {
//           const response2 = await fetch(
//             `${process.env.REACT_APP_API_BASE_URL}/communiUser/joinCommunity`,
//             requestOptions
//           );
//           if (response2.ok) {
//             const data1 = await response1.json();
//             dispatch({
//               type: "UPDATE_COMMUNITIES",
//               payload: data1.profile.listOfCommunities,
//             });
//             navigate("/joinAdditionalCommunity/" + community._id);
//           } else {
//             console.error("Failed to join community on second request");
//           }
//         } else {
//           console.error("Failed to join community on first request");
//         }
//       } catch (error) {
//         console.error("Error joining community:", error);
//       }
//     } else {
//       navigate(`/groupsearch/join/${community._id}`);
//     }
//   };

//   const closeModal = () => {
//     setModalIsOpen(false);
//   };

//   // Helper: get image or placeholder
//   const getImageSrc = () => {
//     if (community.pics && community.pics[0]) {
//       return community.pics[0];
//     }
//     return PLACEHOLDER_IMG;
//   };

//   // Defensive: ensure tags is always an array
//   const tagsArray =
//     typeof community.tags === "string" && community.tags.length > 0
//       ? community.tags.split(",")
//       : Array.isArray(community.tags)
//         ? community.tags
//         : [];

        

//   return (
//     <div id="boxDisplayCommunityBox">
//       <Modal
//         isOpen={modalIsOpen}
//         onRequestClose={closeModal}
//         className="modal"
//         overlayClassName="overlay"
//       >
//         <h2>You are already part of this community!</h2>
//         <p>
//           Go to messages to see who you've connected with or find another
//           community to join :)
//         </p>
//         <button onClick={closeModal}>Close</button>
//       </Modal>

//       <div id="boxDisplayCommunityDetails">
//         <Link to={`/${community.databaseRef}`} className="community-link">
//           <h4 id="boxDisplayCommunityTitle">{community.title}</h4>
//           <div className="image-container">
//             <img
//               src={getImageSrc()}
//               alt="Community"
//               id="boxDisplayCommunityImage"
//               onError={e => { e.target.onerror = null; e.target.src = PLACEHOLDER_IMG; }}
//             />
//           </div>
//         </Link>
//         <div className="line"></div>
//         <div id="boxDisplayCommunityInfo">
//           <h3 id="boxDisplayCommunityLocation">{community.location}</h3>
//           <h3 id="boxDisplayCommunityType">{community.type}</h3>
//         </div>
//         <div className="line"></div>
//         <p id="boxDisplayCommunitySummary">{community.topLevelSummary}</p>
//         <div id="boxDisplayCommunityTagsContainer">
//           {tagsArray.map((tag, index) => (
//             <span
//               key={index}
//               className={`tag${onTagClick ? " tag-clickable" : ""}`}
//               style={onTagClick ? { cursor: "pointer" } : {}}
//               onClick={() => onTagClick && onTagClick(tag.trim())}
//               title={onTagClick ? `Show all groups tagged "${tag.trim()}"` : undefined}
//             >
//               {tag.trim()}
//             </span>
//           ))}
//         </div>
//         <div className="buttonContainer">
//           <button className="button" type="button" onClick={handleJoin}>
//             Join
//           </button>
//           <Link to={`/${community.databaseRef}`} className="buttonSecondary">
//             More Info
//           </Link>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default CommunityDetails;


// // import React, { useState, useEffect } from "react";
// // import { Link, useNavigate } from "react-router-dom";
// // import "./CommunityDetails.css";
// // import { useAuthContext } from "../hooks/useAuthContext";
// // import Modal from "react-modal";
// // import { initializeApp, getApps } from "firebase/app";
// // import { getAuth } from "firebase/auth";
// // import firebase from "../Firebase";
// // import Cookies from "js-cookie"; 

// // const PLACEHOLDER_IMG = "https://cdn.creazilla.com/silhouettes/7966957/people-network-silhouette-f35580-md.png";

// // if (!getApps().length) {
// //   initializeApp(firebase);
// // }

// // Modal.setAppElement("#root");

// // const CommunityDetails = ({ community }) => {
// //   const navigate = useNavigate();
// //   const { user, dispatch } = useAuthContext();
// //   const [modalIsOpen, setModalIsOpen] = useState(false);
// //   const [csrfToken, setCsrfToken] = useState(null);

// //   useEffect(() => {
// //     const fetchCsrfToken = async () => {
// //       const csrfToken = Cookies.get("mytoken");
// //       setCsrfToken(csrfToken);
// //     };
// //     fetchCsrfToken();
// //   }, []);

// //   const handleJoin = async () => {
// //     if (user?.userId) {
// //       if (user.listOfCommunities.includes(community._id)) {
// //         setModalIsOpen(true);
// //         return;
// //       }
// //       try {
// //         const auth = getAuth();
// //         const token = await auth.currentUser.getIdToken(true);
// //         const requestBody = {
// //           communityId: community._id,
// //           userId: user.userId,
// //         };
// //         const requestOptions = {
// //           method: "POST",
// //           headers: {
// //             "Content-Type": "application/json",
// //             Authorization: `Bearer ${token}`,
// //             "X-CSRF-Token": csrfToken,
// //           },
// //           body: JSON.stringify(requestBody),
// //         };
// //         const response1 = await fetch(
// //           `${process.env.REACT_APP_API_BASE_URL}/userProfile/joinCommunity`,
// //           requestOptions
// //         );
// //         if (response1.ok) {
// //           const response2 = await fetch(
// //             `${process.env.REACT_APP_API_BASE_URL}/communiUser/joinCommunity`,
// //             requestOptions
// //           );
// //           if (response2.ok) {
// //             const data1 = await response1.json();
// //             dispatch({
// //               type: "UPDATE_COMMUNITIES",
// //               payload: data1.profile.listOfCommunities,
// //             });
// //             navigate("/joinAdditionalCommunity/" + community._id);
// //           } else {
// //             console.error("Failed to join community on second request");
// //           }
// //         } else {
// //           console.error("Failed to join community on first request");
// //         }
// //       } catch (error) {
// //         console.error("Error joining community:", error);
// //       }
// //     } else {
// //       navigate(`/groupsearch/join/${community._id}`);
// //     }
// //   };

// //   const closeModal = () => {
// //     setModalIsOpen(false);
// //   };

// //   // Helper: get image or placeholder
// //   const getImageSrc = () => {
// //     if (community.pics && community.pics[0]) {
// //       return community.pics[0];
// //     }
// //     return PLACEHOLDER_IMG;
// //   };

// //   // Defensive: ensure tags is always an array
// //   const tagsArray =
// //     typeof community.tags === "string" && community.tags.length > 0
// //       ? community.tags.split(",")
// //       : [];

// //   return (
// //     <div id="boxDisplayCommunityBox">
// //       <Modal
// //         isOpen={modalIsOpen}
// //         onRequestClose={closeModal}
// //         className="modal"
// //         overlayClassName="overlay"
// //       >
// //         <h2>You are already part of this community!</h2>
// //         <p>
// //           Go to messages to see who you've connected with or find another
// //           community to join :)
// //         </p>
// //         <button onClick={closeModal}>Close</button>
// //       </Modal>

// //       <div id="boxDisplayCommunityDetails">
// //         <Link to={`/${community.databaseRef}`} className="community-link">
// //           <h4 id="boxDisplayCommunityTitle">{community.title}</h4>
// //           <div className="image-container">
// //             <img
// //               src={getImageSrc()}
// //               alt="Community"
// //               id="boxDisplayCommunityImage"
// //               onError={e => { e.target.onerror = null; e.target.src = PLACEHOLDER_IMG; }}
// //             />
// //           </div>
// //         </Link>
// //         <div className="line"></div>
// //         <div id="boxDisplayCommunityInfo">
// //           <h3 id="boxDisplayCommunityLocation">{community.location}</h3>
// //           <h3 id="boxDisplayCommunityType">{community.type}</h3>
// //         </div>
// //         <div className="line"></div>
// //         <p id="boxDisplayCommunitySummary">{community.topLevelSummary}</p>
// //         <div id="boxDisplayCommunityTagsContainer">
// //           {tagsArray.map((tag, index) => (
// //             <span key={index} className="tag">
// //               {tag.trim()}
// //             </span>
// //           ))}
// //         </div>
// //         <div className="buttonContainer">
// //           <button className="button" type="button" onClick={handleJoin}>
// //             Join
// //           </button>
// //           <Link to={`/${community.databaseRef}`} className="buttonSecondary">
// //             More Info
// //           </Link>
// //         </div>
// //       </div>
// //     </div>
// //   );
// // };

// // export default CommunityDetails;
